'use client';

import { cn } from '@shared/components/shadcn';
import { LottolandSmileLogo, Spinner } from '@shared/icons';
import type { ComponentProps } from 'react';
import { IconBadge } from '../IconBadge/IconBadge';

type FeedbackSuccessProps = {
  primaryText: string;
  secondaryText?: string;
} & ComponentProps<'div'>;

function FeedbackSuccess({ primaryText, secondaryText, className, ...props }: FeedbackSuccessProps) {
  return (
    <div className={cn(`w-full h-full flex items-center justify-center`, className)} data-testid="feedback-success" aria-busy="true" {...props}>
      <div className="flex flex-col items-center gap-4 text-center py-12" role="status" aria-live="polite">
        <div aria-hidden="true">
          <IconBadge icon={LottolandSmileLogo} shapeType="square" />
        </div>
        <div id="redirecting-text">
          <p>{primaryText}</p>
          {secondaryText && <p>{secondaryText}</p>}
        </div>
        <Spinner size="small" className="w-5 h-5 animate-spin text-accent-green" aria-hidden="true" />
      </div>
    </div>
  );
}

export { FeedbackSuccess, type FeedbackSuccessProps };
